var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "70px",
    height: "70px",
    viewBox: "0 0 70 70",
    enableBackground: "new 0 0 70 70",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#0099CC",
    cx: 35,
    cy: 35,
    r: 35
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M48.562,25.768h-1.545v-6.18c0-6.816-5.544-12.36-12.36-12.36s-12.36,5.544-12.36,12.36v6.18h-1.545 c-2.554,0-4.635,2.079-4.635,4.635v21.629c0,2.557,2.081,4.635,4.635,4.635h27.81c2.554,0,4.635-2.078,4.635-4.635V30.402 C53.196,27.846,51.115,25.768,48.562,25.768z M26.417,19.588c0-4.545,3.695-8.24,8.24-8.24c4.545,0,8.239,3.695,8.239,8.24v6.18 H26.417V19.588z M36.716,41.675v4.692c0,1.137-0.921,2.06-2.06,2.06s-2.06-0.923-2.06-2.06v-4.692 c-1.226-0.715-2.06-2.03-2.06-3.549c0-2.271,1.848-4.119,4.12-4.119s4.12,1.848,4.12,4.119 C38.776,39.646,37.942,40.96,36.716,41.675z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/login.a900964bb2f0e5e1de954e719f837b7b.svg";
export { ForwardRef as ReactComponent };